import { useRoutes, useNavigate, useLocation } from "react-router-dom";
import routes from "./routes";
import { firebaseConfig, firebaseConfigForProduction } from "./config";
import { UserApp } from "@rewardle/apps.userapp";
import menuItems from "./utils/MenuItems";
import { Themeprovider } from "@rewardle/apps.theme.themeprovider";

// Define public routes that don't require authentication
const publicRoutes = [
  "/subscription/managemerchantsubscription",
  "/subscription/managerewardlesubscription"
];

function App() {
  const content: any = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();
  const isLive = process?.env?.REACT_APP_IS_LIVE === "true";

  const firebaseConfigData = isLive
    ? firebaseConfigForProduction
    : firebaseConfig;

  // Check if current route is public
  const normalizedPathname = (location.pathname || "").replace(/\/+$/, "");
  const isPublicRoute = publicRoutes.includes(normalizedPathname);

  // If it's a public route, render without authentication
  if (isPublicRoute) {
    return <Themeprovider>{content}</Themeprovider>;
  }

  // Otherwise, render with authentication
  return (
    <>
      <UserApp
        firebaseConfig={firebaseConfigData}
        apiDomain={""}
        menuItems={menuItems}
        navigate={navigate}
      >
        {content}
      </UserApp>
    </>
  );
}

export default App;
